import { isServer } from '@flipster/utils/env-helper';

export const getFlipsterUrl = () => {
  if (isServer) return 'https://flipster.io';
  const { host } = window.location;
  const rootDomain = host.split('.').slice(-2).join('.');

  switch (rootDomain) {
    case 'flipster.io':
      return 'https://flipster.io';
    case 'flipster.me':
      return 'https://flipster.me';
    default:
      if (
        // internal
        rootDomain === 'prex.run' ||
        rootDomain === 'yoda.mobi' ||
        rootDomain === 'prex.website' ||
        // local
        rootDomain.includes('.localhost') ||
        rootDomain.startsWith('0.0.0.0') ||
        rootDomain.startsWith('127.0.0.1')
      ) {
        // versioned domain
        if (rootDomain === 'prex.run' && host.startsWith('v')) {
          return `https://${host.replace(/v[\d-]+\./, '').replace(/app[-.]/, '')}`;
        }
        return `https://${host.replace(/app[-.]/, '')}`;
      }
      return `https://${rootDomain}`;
  }
};
